import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetQuestionListSucceed, EGetQuestionListActionType } from './types';
import { IQuestionList } from '../../../types/questionList';

export const getQuestionListSucceed: (data: IQuestionList) => TGetQuestionListSucceed = actionGenerator<
  EGetQuestionListActionType.Succeed,
  IQuestionList
>(EGetQuestionListActionType.Succeed);
